import React from 'react'

const rowCount = (d, name) => d.rows?.find((r) => r.event_name === name)?.event_count ?? 0
const none = () => null

// "<x> funnel variants": [{ variant: 'A', event_count }]
const variant = (key, v) => (d) => d[key]?.find((x) => x.variant === v)?.event_count ?? 0

// "Funnel A": { "Chat started": 7, ... }  -> null (shows "—") if that funnel isn't in the response
const funnel = (name, step) => (d) => d[name]?.[step] ?? null

const REG = 'registration page funnel variants'
const PAYWALL = 'paywall displayed funnel variants'
const CHECKOUT = 'checkout initiated funnel variants'

const TRUNK = [
    { label: 'Age gate viewed', tone: 'blue', get: (d) => rowCount(d, 'age_gate_open') },
    { label: 'Age gate passed', tone: 'yellow', get: (d) => rowCount(d, 'age_gate_confirm') },
    { label: 'Splash started', tone: 'yellow', get: (d) => rowCount(d, 'onboarding_video_open') },
    { label: 'Splash completed', tone: 'cream', get: (d) => rowCount(d, 'onboarding_video_complete') },
]

const FLOW_A = [
    { label: 'Email/registration prompt displayed', get: variant(REG, 'A') },
    { label: 'Email captured', get: funnel('Funnel A', 'Registered') },
    { label: '5 messages', get: funnel('Funnel A', 'Sent 5 messages') },
    { label: '10 messages', get: funnel('Funnel A', 'Sent 10 messages') },
    { label: '25 messages', get: funnel('Funnel A', 'Sent 25 messages') },
    { label: '50 messages', get: funnel('Funnel A', 'Sent 50 messages') },
    { label: 'Paywall displayed', get: variant(PAYWALL, 'A') },
    { label: 'Checkout initiated', get: variant(CHECKOUT, 'A') },
    { label: 'Subscription completed', get: funnel('Funnel A', 'Subscribed') },
    { label: 'Return visit', get: funnel('Funnel A', 'Used after subscribe') },
    { label: 'Cancellation', get: funnel('Funnel A', 'Cancelled') },
    { label: 'Reactivation', get: none },
]

const FLOW_B = [
    { label: 'Trial started', get: funnel('Funnel B', 'Trial started') },
    { label: 'Chat started', get: funnel('Funnel B', 'Chat started') },
    { label: 'First AI response', get: funnel('Funnel B', 'First ai response') },
    { label: '5 messages', get: funnel('Funnel B', 'Sent 5 messages') },
    { label: 'Email/registration prompt displayed', get: variant(REG, 'B') },
    { label: 'Email captured', get: funnel('Funnel B', 'Registered') },
    { label: '10 messages', get: funnel('Funnel B', 'Sent 10 messages') },
    { label: '25 messages', get: funnel('Funnel B', 'Sent 25 messages') },
    { label: '50 messages', get: funnel('Funnel B', 'Sent 50 messages') },
    { label: 'Paywall displayed', get: variant(PAYWALL, 'B') },
    { label: 'Checkout initiated', get: variant(CHECKOUT, 'B') },
    { label: 'Subscription completed', get: funnel('Funnel B', 'Subscribed') },
    { label: 'Return visit', get: funnel('Funnel B', 'Used after subscribe') },
    { label: 'Cancellation', get: funnel('Funnel B', 'Cancelled') },
    { label: 'Reactivation', get: none },
]

const Chain = ({ steps, tone, d }) => (
    <ol className="dfd__chain">
        {steps.map((s, i) => {
            const count = s.get(d)
            return (
                <li
                    key={i}
                    className={`dfd-node dfd-node--${s.tone || tone} ${count === null ? 'is-empty' : ''}`}
                >
                    <span className="dfd-node__label">{s.label}</span>
                    <strong className="dfd-node__count">{count ?? '—'}</strong>
                </li>
            )
        })}
    </ol>
)

const UserFlowDfd = ({ data, rows }) => {
    const d = data ?? (Array.isArray(rows) ? { rows } : rows) ?? {}

    return (
        <div className="dfd">
            <h3 className="dfd__title">User Flow</h3>

            <div className="dfd__trunk">
                <Chain steps={TRUNK} d={d} />
            </div>

            <div className="dfd__split">
                <span className="dfd__stem" />
                <span className="dfd__bar" />
            </div>

            <div className="dfd__branches">
                <div className="dfd__col">
                    <span className="dfd__tag">Flow A</span>
                    <Chain steps={FLOW_A} tone="lavender" d={d} />
                </div>
                <div className="dfd__col">
                    <span className="dfd__tag">Flow B</span>
                    <Chain steps={FLOW_B} tone="orange" d={d} />
                </div>
            </div>
        </div>
    )
}

export default UserFlowDfd